import {Injectable} from "@angular/core";
import {Http, RequestOptions, Response} from "@angular/http";
import {UtilService} from "../util";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";
import "rxjs/add/observable/of";
import {UserStaff} from "../../models/user-staff.model";
import {Observable} from "rxjs/Observable";

@Injectable()
export class OfficeStaffService {
  constructor(private http: Http, private utilService: UtilService) {
  }

  getAllStaff(searchCriteria: SearchCriteria, showAll: boolean = false) {
    let url = "/system_users";
    let queryParams = this.utilService.setQueryParams({
      page: searchCriteria.PageNumber,
      sort: searchCriteria.Sort,
      order: searchCriteria.Order,
      search: searchCriteria.SearchTerm,
      show_all: showAll ? 'true' : 'false'
    });
    let options = new RequestOptions({params: queryParams});
    return this.http
      .get(url, options)
      .map((res: Response) => {
        return (this.utilService.outputParser(res) || []);
      })
      .catch(this.utilService.handleError);
  }

  getStaffById(id: number) {
    let url = `/system_users/${id}`;
    return this.http
      .get(url)
      .map((res: Response) => {
        const staff = this.utilService.outputParser(res) || false;
        if (!staff) return {};
        if (staff.Username) {
          staff.Email = staff.Username;
        }
        return staff;
      })
      .catch(this.utilService.handleError);
  }

  updateStaff(staff: UserStaff) {
    let url = `/system_users/${staff.Id}/profile`;
    return this.http
      .put(url, staff)
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }

  getRoles(): Observable<any> {
    return this.http.get('/roles')
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }

  createStaff(staff: UserStaff) {
    let url = `/system_users`;
    const data = {
      ...staff,
      Username: staff.Email
    };
    return this.http
      .post(url, data)
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }

  checkStaffExists(staff: UserStaff) {
    let url = "/system_users/exists";
    let queryParams = this.utilService.setQueryParams({
      Id: staff.Id,
      Email: staff.Email
    });
    let options = new RequestOptions({params: queryParams});
    return this.http
      .get(url, options)
      .map((res: Response) => {
        return (this.utilService.outputParser(res) || {}).Exists || false;
      })
      .catch(this.utilService.handleError);
  }

  setVisibility(id: string, visible: boolean) {
    const url = `/system_users/${id}`;
    return this.http.patch(url, {
      visible
    }).map((res: Response) => {
      return this.utilService.outputParser(res) || {};
    }).catch(this.utilService.handleError);
  }

  deactivateStaff(staff: UserStaff) {
    let url = `/user/${staff.Id}/deactivate`;
    return this.http
      .post(url, {})
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }

  resendActivationEmail(staff: UserStaff) {
    let url = `/user/%{staff.Id}/resend`;
    return this.http
      .post(url, {})
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/services/office-staff/office-staff.service.ts